module.exports = __webpack_public_path__ + "static/img/Facebook.3d5f01b3.png";